import shouldShowUnstackedReadingPane from 'owa-mail-organization-settings/lib/utils/shouldShowUnstackedReadingPane';

import {
    flaggedMailListItemColor,
    expandedSelectedHeader,
    expandedMailListItemColor,
    selectedMailListItemColor,
    selectedMailListItemColor_deprecated,
    pinnedMailListItemColor,
    regularMailListItemColor,
    flaggedMailListItemColor_deprecated,
} from 'owa-mail-listitem-styles/lib/scss/MailListItemBackgroundColors.scss';

export default function useBackgroundColorClass(
    isSelected: boolean,
    isFlagged: boolean,
    isPinned: boolean,
    isChecked: boolean,
    supportsFlagging: boolean,
    supportsPinning: boolean,
    isRowExpanded: boolean,
    numberOfSelectedItemParts: number | undefined,
    showFocusSelectStyles: boolean
): string {
    const flaggedMailListItemColorClassName = showFocusSelectStyles
        ? flaggedMailListItemColor
        : flaggedMailListItemColor_deprecated;

    if (isSelected || isChecked) {
        const selectedMailListItemColorClassName = showFocusSelectStyles
            ? selectedMailListItemColor
            : selectedMailListItemColor_deprecated;

        const expandedMailListItemColorClassName = showFocusSelectStyles
            ? regularMailListItemColor
            : expandedMailListItemColor;

        const showOnlySubject = shouldShowUnstackedReadingPane() && isRowExpanded;
        if (showOnlySubject) {
            if (supportsFlagging && isFlagged) {
                return flaggedMailListItemColorClassName;
            }

            // There is never a scenario where numberOfSelectedItemParts is zero. To be cautious, I will wait until flight cleanup to remove it.
            const isHeaderSelected =
                !showFocusSelectStyles && isRowExpanded && numberOfSelectedItemParts == 0;
            return isHeaderSelected ? expandedSelectedHeader : expandedMailListItemColorClassName;
        }

        // If row is expanded, then only apply selection UX if that row is also
        // checked. Otherwise, we want to show the expanded background color.
        if (isRowExpanded) {
            return isChecked
                ? selectedMailListItemColorClassName
                : expandedMailListItemColorClassName;
        }

        return selectedMailListItemColorClassName;
    } else if (supportsFlagging && isFlagged) {
        return flaggedMailListItemColorClassName;
    } else if (!showFocusSelectStyles && supportsPinning && isPinned) {
        return pinnedMailListItemColor; // no longer show background color for pinned items when focusselect flight is enabled
    } else {
        return regularMailListItemColor;
    }
}
